// Every gateway call the member area makes.
export { default as usersApi } from "./users";
export { default as coursesApi } from "./courses";
export { default as ordersApi } from "./orders";
export { default as mediaApi } from "./media";
export { default as categoriesApi } from "./categories";
export { default as reviewsApi } from "./reviews";
